import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-69" data-mp="3gfiv8kpoaff6">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px"
    }} data-id="element-70" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-xl font-black text-plum" data-id="element-71" data-mp="36pft9v0kpr4p">
          THE AGE-IN-PLACE BLUEPRINT<span className="align-super text-xs" data-id="element-72" data-mp="36n3axgqwler4">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-73" data-mp="3ufju5umdncs0">
          The visual method to maintain aging in place from absolute zero: senior care protocols,
          complete assessment systems, daily wellness frameworks and prevention criteria in 30
          days.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-74" data-mp="3qblvtm4vm600">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="2a19tbleljmwr">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3lalhzkmm4fwl" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-77" data-mp="3gbin2t0cjq2c">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-78" data-mp="3v9az3b6opwbs" /> @sigmasmart.en
          </a>
          
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-79" data-mp="3q7byua68rfj2">
          🏥 “Your first care protocol starts today.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-80" data-mp="34p9n8wwbwis">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-81" data-mp="ht3ajear5awp">
            Terms & Conditions
          </a>
          <span data-id="element-82" data-mp="cu8qk911tgb0">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="cw34329zq652">
            Privacy Policy
          </a>
          <span data-id="element-84" data-mp="msg5ynfovqaw">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-85" data-mp="mt7s77necboi">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-86" data-mp="tt9z0dyrgtw6">
          © 2026 THE AGE-IN-PLACE BLUEPRINT™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}